import { useContext } from 'react';

import { ConfigContext } from 'client/common/contexts/config';

export function useConfig() {
    return useContext(ConfigContext);
}
